module.exports = __webpack_public_path__ + "img/1.b7b9606e.svg";